(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.sabinatProductBuyNowInitialized) {
  window.sabinatProductBuyNowInitialized = true;

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest('[data-sabinat-buy-now]');

    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const productForm = button.closest('product-form-component');
    const form = productForm?.querySelector('form');
    const variantId = form?.querySelector('[ref="variantId"]')?.value;
    const quantity = form?.querySelector('[ref="quantityInput"]')?.value || '1';
    const cartUrl = button.dataset.cartUrl;

    if (!variantId || !cartUrl) return;

    window.location.assign(`${cartUrl}/${variantId}:${quantity}`);
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sabinatura-package-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sabinat-package-selector')) {
    class SabinatPackageSelector extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) this.updateSelection(event.target, true);
        });

        this.productForm = [...document.querySelectorAll('form[action*="/cart/add"]')]
          .find((form) => form.querySelector('[name="id"]')?.value === this.dataset.variantId);
        this.quantityInput = this.productForm?.querySelector('[name="quantity"]');
        this.syncingQuantity = false;
        this.productForm?.addEventListener('change', (event) => {
          if (event.target.matches('[name="quantity"]')) this.updateFromQuantity(event.target);
        });
        this.productForm?.addEventListener('input', (event) => {
          if (event.target.matches('[name="quantity"]')) this.updateFromQuantity(event.target);
        });

        const previewMode = Boolean(window.Shopify?.designMode) || new URLSearchParams(window.location.search).get('bf_preview') === '1';
        const startsAt = Date.parse(this.dataset.startsAt);
        const endsAt = Date.parse(this.dataset.endsAt);
        const now = Date.now();
        const saleIsLive = now >= startsAt && now < endsAt;
        const offerIsVisible = saleIsLive || previewMode;
        this.querySelector('[data-offer-content]').hidden = !offerIsVisible;
        this.querySelector('[data-standard-price]').hidden = offerIsVisible;
        this.querySelector('[data-standard-shipping]').hidden = offerIsVisible;
        this.querySelector('[data-preview-note]').hidden = !previewMode || saleIsLive;
        if (offerIsVisible) this.updateSelection(this.querySelector('input[type="radio"]:checked'), true);
      }

      updateSelection(input, syncQuantity) {
        if (!input) return;
        this.querySelectorAll('[data-option]').forEach((option) => {
          option.classList.toggle('is-selected', option.contains(input));
        });

        const quantity = Number(input.value);
        const savings = Number(input.dataset.savings);
        const formatter = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
        const savingsDisplay = this.querySelector('[data-savings-display]');
        savingsDisplay.hidden = savings === 0;
        savingsDisplay.textContent = savings > 0 ? `Ahorras ${formatter.format(savings)}` : '';

        if (syncQuantity && this.quantityInput && Number(this.quantityInput.value) !== quantity) {
          this.syncingQuantity = true;
          this.quantityInput.value = String(quantity);
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.syncingQuantity = false;
        }
      }

      updateFromQuantity(input) {
        if (this.syncingQuantity) return;
        let quantity = Math.max(1, Number.parseInt(input.value || '1', 10));
        if (quantity > 3) {
          quantity = 3;
          input.value = '3';
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const option = this.querySelector(`input[type="radio"][value="${quantity}"]`);
        if (option) this.updateSelection(option, false);
      }
    }

    customElements.define('sabinat-package-selector', SabinatPackageSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
